import { Errors, Form as FormType, UpdateForm } from '.'
import InputDate from 'components/inputs/Date'
import React from 'react'

interface FormProps {
  form: FormType
  errors: Errors
  updateForm: UpdateForm
  validateFields: () => void
}

const Form: React.FC<FormProps> = ({ form, errors, updateForm, validateFields }) => {
  return (
    <>
      <div className="subtitle">
        Dodasz pomnik na mapę w miejscu, w którym obecnie się znajdujesz
      </div>
      <div className="myInput">
        <label>{errors.name ? errors.name : 'Imię i nazwisko'}</label>
        <input
          className={errors.name ? 'error' : ''}
          type="text"
          placeholder='Wpisz imię i nazwisko'
          value={form.name}
          onChange={(e) => {
            updateForm('name', e.target.value)
            if (errors.name) {
              validateFields()
            }
          }}
        />
      </div>

      <InputDate
          value={form.birth}
          onChange={(date) => {
            updateForm('birth', date)
            if (errors.birth) validateFields();
          }}
          label={errors.birth || 'Data urodzenia'}
          error={errors.birth}
        />

        <InputDate
          value={form.death}
          onChange={(date) => {
            updateForm('death', date)
            if (errors.death) validateFields();
          }}
          label={errors.death || 'Data śmierci'}
          error={errors.death}
          today
        />

      <div className="myInput">
        <label>Zdjęcie</label>
        <input
          onClick={() => document.getElementById('fileInput')?.click()}
          placeholder="Kliknij, aby zrobić zdjęcie pomnika"
          value={form.photo?.name || ''}
          readOnly
        />
        <input
          id="fileInput"
          type="file"
          accept="image/*"
          capture="environment"
          onChange={(event) => {
            if (event.target.files && event.target.files[0]) {
              updateForm('photo', event.target.files[0])
            }
          }}
          style={{ display: 'none' }}
        />
      </div>
    </>
  )
}

export default Form